const GEORGIA_UNIT_LABELS: Record<string, string> = {
  square_foot: 'square foot', linear_foot: 'linear foot',
  square_yard: 'square yard', cubic_yard: 'cubic yard',
};

/** Keep reviewed measurement units readable without exposing arbitrary codes. */
export const normalizeGeorgiaUnitText = (value: unknown): string | null => {
  if (typeof value !== 'string') return null;
  const unit = value.trim();
  if (!unit || unit.length > 80 || unit.startsWith('/')
    || unit.startsWith('file:') || unit.includes('://')) return null;
  if (Object.prototype.hasOwnProperty.call(GEORGIA_UNIT_LABELS, unit)) {
    return GEORGIA_UNIT_LABELS[unit];
  }
  return /^[a-z][a-z0-9]*(?:_[a-z0-9]+)+$/i.test(unit) ? null : unit;
};
